import { render, staticRenderFns } from "./shopFreightTemplate.vue?vue&type=template&id=868ea3b6&"
import script from "./shopFreightTemplate.vue?vue&type=script&lang=js&"
export * from "./shopFreightTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports